<template>
  <div class="h-fit p-4 flex flex-col glass-frosted rounded-5xl text-l-medium">
    <div class="flex flex-col gap-2 flex-1">
      <Button
        v-for="item in visibleMenuItems"
        :key="item.key"
        :color="activeKey === item.key ? 'normal' : 'text-b-w'"
        :variant="activeKey === item.key ? 'fill' : 'frameless'"
        :active="activeKey === item.key"
        @click="handleSelect(item)"
      >
        <div class="w-full text-left">{{ item.label }}</div>
      </Button>
      <!-- <div
        v-for="item in visibleMenuItems"
        :key="item.key"
        class="flex items-center px-6 py-3 text-black-white rounded-6xl cursor-pointer transition-all duration-200"
        :class="[activeKey === item.key && 'bg-neutral-light-default']"
        @click="handleSelect(item)"
      >
        {{ item.label }}
      </div> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { isElectron } from '@/utils/env'
  import { Button } from '@rapoo/element'

  const props = defineProps<{
    active?: string
  }>()

  const emit = defineEmits<{
    (e: 'change', key: string): void
  }>()

  const { t } = useI18n()
  const activeKey = ref(props.active || 'theme')

  watch(
    () => props.active,
    (val) => {
      if (val) activeKey.value = val
    },
  )

  interface MenuItem {
    label: string
    key: string
    hidden?: boolean
    action?: () => void
  }
  const menuItems = computed<MenuItem[]>(() => {
    return [
      { label: t('setting.sidebar.theme'), key: 'theme' },
      { label: t('setting.sidebar.language'), key: 'language' },
      {
        label: t('setting.sidebar.pairing'),
        key: 'pairing',
        hidden: import.meta.env.VITE_CHANNEL === 'china_cybercafe',
      },
      { label: t('setting.sidebar.about'), key: 'about' },
    ]
  })
  console.log(import.meta.env.VITE_CHANNEL)

  const visibleMenuItems = computed(() => {
    return menuItems.value.filter((item) => !item.hidden || isElectron())
  })

  const handleSelect = (item: MenuItem) => {
    if (item.action) {
      item.action()
      return
    }
    activeKey.value = item.key
    emit('change', item.key)
  }
</script>

<style lang="scss" scoped></style>
